import { useState } from 'react';
import { api } from '../lib/api.js';

// ─── Quick Log Temp Button ─────────────────────────────────────────────────────
export function QuickLogTempBtn({ equipment, locationId, userId, onLogged }) {
  const [open, setOpen] = React.useState(false);
  const [temp, setTemp] = React.useState('');
  const [period, setPeriod] = React.useState('Opening');
  const [saving, setSaving] = React.useState(false);
  async function handleLog(e) {
    e.preventDefault(); e.stopPropagation();
    if (!temp) return;
    setSaving(true);
    try {
      await api('POST', `/api/equipment/${equipment.id}/temperature`, { temperature: parseFloat(temp), period, logged_by: userId, location_id: locationId });
      setOpen(false); setTemp(''); onLogged();
    } finally { setSaving(false); }
  }
  if (!open) return (
    <button onClick={e => { e.stopPropagation(); setOpen(true); }}
      className="px-2 py-1.5 bg-blue-50 text-blue-700 text-xs rounded-lg hover:bg-blue-100 transition-all font-medium flex-shrink-0">
      🌡 Log Temp
    </button>
  );
  return (
    <div onClick={e => e.stopPropagation()} className="flex items-center gap-1 flex-shrink-0">
      <input type="number" step="0.1" value={temp} onChange={e => setTemp(e.target.value)}
        className="w-16 border border-gray-300 rounded px-2 py-1 text-xs text-ink bg-white focus:outline-none focus:ring-1 focus:ring-blue-300"
        placeholder="°F" autoFocus />
      <select value={period} onChange={e => setPeriod(e.target.value)}
        className="border border-gray-300 rounded px-1 py-1 text-xs text-ink bg-white focus:outline-none">
        {['Opening','Midday','Closing'].map(p => <option key={p}>{p}</option>)}
      </select>
      <button onClick={handleLog} disabled={saving}
        className="px-2 py-1 bg-green-600 text-white text-xs rounded font-semibold hover:bg-green-700 disabled:opacity-50">✓</button>
      <button onClick={e => { e.stopPropagation(); setOpen(false); setTemp(''); }}
        className="text-gray-400 hover:text-gray-600 text-xs px-1">×</button>
    </div>
  );
}
